// extracted by mini-css-extract-plugin
export default {"wrapper":"RoundedButton_wrapper__X8JWD","button":"RoundedButton_button__LLiFF"};